"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _Input = require("@ccw-pwa-ui/Input");
var _Modal = require("@ccw-pwa-ui/Modal");
require("../styles/ImageUpload.scss");
var _Button = require("@ccw-pwa-ui/Button");
var _ConnectionLoader = require("@ccw-pwa-ui/ConnectionLoader");
var _Stack = _interopRequireDefault(require("@mui/material/Stack"));
var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _images = _interopRequireDefault(require("../common_features/assets/images"));
const ImageUpload = _ref => {
  let {
    navHeading,
    onBackPress,
    onClickCancel,
    leftArrow,
    cancelText,
    headerText,
    subContent,
    buttonTitle,
    uploadPhotos,
    displayPhotosModal,
    isOneSelected,
    onOptionSelect,
    isTwoSelected,
    videoRef,
    handleFileChange,
    onModalCancel,
    selectedImages,
    limitExceededText,
    limitDetailText,
    deleteIcon,
    okText,
    isLimitExceeded,
    limitOkPress,
    deleteIconClick,
    imagePlaceholder,
    continueText,
    deleteText,
    continueClicked,
    deleteModal,
    trash,
    onCancelDelete,
    deleteHandler,
    currentPage,
    totalPage,
    continuePress,
    checkmark,
    checkmarkStyle,
    camDivStyle,
    camLabelStyle,
    hideImageButton,
    saveText,
    subText,
    descriptionChange,
    description,
    isUpdating,
    windowLayout,
    uploadingVisible,
    uploading,
    totalImagesUploaded,
    totalImagesSelected,
    continueDisabled,
    notUploaded,
    imageNotUploadedClick,
    uploadDisabled
  } = _ref;
  return isUpdating ? /*#__PURE__*/_react.default.createElement(_ConnectionLoader.ConnectionLoader, null) : /*#__PURE__*/_react.default.createElement("div", {
    className: "image-layout"
  }, /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: navHeading,
    handleBack: onBackPress,
    handleCancle: onClickCancel,
    leftArrowImage: leftArrow,
    rightNavHeading: cancelText
  }), currentPage && /*#__PURE__*/_react.default.createElement("div", {
    className: "stepCountClass"
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontWeight: 600
    }
  }, "Step ", currentPage, " "), " of ", totalPage), "      ", /*#__PURE__*/_react.default.createElement("div", {
    className: "imageUploadClass"
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "header-text",
    className: "header-text"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: headerText
  })), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "sub-text",
    headerText: subText,
    headerStyle: {
      fontFamily: 'Poppins',
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '22px',
      letterSpacing: '0px',
      textAlign: 'left'
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "max-image"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "sub-text",
    headerText: subContent,
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 600,
      lineHeight: "22px"
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "max-photos"
  }, '(Max. 10 photos)')), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'relative',
      minHeight: '50vh'
    },
    "data-testid": "sub-text"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "outline-primary-long",
    title: buttonTitle,
    buttonStyle: {
      borderWidth: '2px',
      fontWeight: '800',
      marginTop: '15px',
      width: windowLayout ? "50%" : "94%"
    },
    onClick: uploadPhotos,
    disabled: uploadDisabled
  }), uploadingVisible && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      margin: '10px',
      flexDirection: 'row',
      display: 'flex',
      justifyContent: 'right'
    }
  }, /*#__PURE__*/_react.default.createElement(_Stack.default, {
    sx: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    variant: "determinate",
    sx: {
      opacity: '100%',
      color: theme => theme.palette.mode === 'light' ? 'rgb(0, 110, 150)' : '#006E96',
      animationDuration: '550ms',
      position: 'absolute'
    },
    size: 20,
    thickness: 7,
    value: totalImagesUploaded / totalImagesSelected * 100
  }), /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    variant: "determinate",
    sx: {
      opacity: '40%',
      color: theme => theme.palette.mode === 'light' ? 'rgb(0, 110, 150)' : '#006E96'
    },
    value: 100,
    size: 20,
    thickness: 7
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontSize: '13px',
      marginLeft: '10px'
    }
  }, "".concat(totalImagesUploaded, " of ").concat(totalImagesSelected, " photos uploaded"))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "imageViewLayout",
    style: {
      marginRight: 20
    }
  }, displayPhotosModal && /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "pop-up"
  }, /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: displayPhotosModal,
    modalDetailTextStyle: {
      marginBottom: '20px'
    },
    text4Style: [windowLayout ? {
      cursor: "no-drop",
      opacity: "0.4",
      fontFamily: 'Poppins',
      fontSize: '16px',
      fontWeight: 700,
      lineHeight: '24px',
      letterSpacing: '0px',
      textAlign: 'left',
      height: '50px',
      marginTop: '10px',
      marginBottom: '10px',
      borderBottom: "1px solid #EBEBEB"
    } : {
      fontFamily: 'Poppins',
      fontSize: '16px',
      fontWeight: 700,
      lineHeight: '24px',
      letterSpacing: '0px',
      textAlign: 'left',
      color: '#006E96',
      height: '50px',
      marginTop: '10px',
      marginBottom: '10px',
      borderBottom: "1px solid #EBEBEB"
    }, {
      fontFamily: 'Poppins',
      fontSize: '16px',
      fontWeight: 700,
      lineHeight: '24px',
      letterSpacing: '0px',
      textAlign: 'left',
      color: '#006E96',
      height: '50px',
      marginTop: '10px',
      marginBottom: '10px',
      borderBottom: "1px solid #EBEBEB"
    }],
    modalDetailText4: [{
      name: 'Take Photo',
      iconRight: isOneSelected,
      onSelect: () => windowLayout ? () => {} : onOptionSelect(1)
    }, {
      name: 'Photo Library',
      iconRight: isTwoSelected,
      imageButton: true,
      onSelect: () => onOptionSelect(2)
    }],
    imageButtonText: 'Continue',
    imageButton: continuePress,
    checkmark: checkmark,
    camDivStyle: camDivStyle,
    hideImageButton: hideImageButton,
    camLabelStyle: camLabelStyle,
    checkmarkStyle: checkmarkStyle,
    capture: isOneSelected ? 'camera' : null,
    cameraSelected: isOneSelected,
    videoRef: videoRef,
    ContinueText: saveText,
    fileSelected: isTwoSelected || isOneSelected,
    imageButtonAction: isOneSelected || isTwoSelected ? handleFileChange : null,
    negativeButtonActionTitle: cancelText,
    negativeAvtion: onModalCancel,
    imageButtonStyle: {
      width: '100%',
      height: '45px',
      fontWeight: 700,
      alignSelf: 'center'
    }
  })), selectedImages && (selectedImages === null || selectedImages === void 0 ? void 0 : selectedImages.map((image, index) => {
    var _description$index, _description$index2, _description$index3;
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        paddingBottom: "10px"
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: "imageContainer"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
      src: uploading ? _images.default.CloseIcon.default : deleteIcon,
      onClick: () => deleteIconClick(image),
      className: "deleteIcon",
      "data-testid": "image-area",
      alt: "delete"
    }), uploading ? /*#__PURE__*/_react.default.createElement("div", {
      style: {
        height: "200px",
        display: "flex",
        flexDirection: "column",
        background: '#F4F4F4'
      }
    }, /*#__PURE__*/_react.default.createElement("img", {
      style: {
        display: "flex",
        margin: "auto",
        height: "70px",
        width: "70px",
        flex: 6
      },
      src: _images.default.imageUpload.default,
      className: "image",
      alt: "img-uploading"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "uploadingText"
    }, "Uploading...")) : /*#__PURE__*/_react.default.createElement("img", {
      src: image,
      className: "image",
      alt: "selected-img"
    })), /*#__PURE__*/_react.default.createElement(_Input.Input, {
      inputStyle: {
        borderRadius: 10,
        marginBottom: "50px",
        marginTop: "30px"
      },
      value: description[index] ? description[index] : "",
      onchange: e => descriptionChange(e, index),
      placeholder: imagePlaceholder,
      maxLength: 100
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "description"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "sub-notes",
      "data-testid": "sub-notes"
    }, ((_description$index = description[index]) === null || _description$index === void 0 ? void 0 : _description$index.length) >= 0 ? "You have ".concat(((_description$index2 = description[index]) === null || _description$index2 === void 0 ? void 0 : _description$index2.length) <= 100 ? 100 - ((_description$index3 = description[index]) === null || _description$index3 === void 0 ? void 0 : _description$index3.length) : 0, " characters remaining") : "Maximum character limit : 100"))));
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'absolute',
      bottom: '0px',
      left: '50%',
      right: 0,
      minWidth: '335px',
      maxWidth: '860px',
      transform: 'translateX(-50%)'
    },
    "data-testid": "continue-click"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: continueText,
    buttonContainerStyle: {
      marginTop: '10px',
      position: 'absolute',
      width: '100%'
    },
    buttonStyle: {
      borderWidth: '2px',
      fontWeight: '800'
    },
    onClick: continueClicked,
    disabled: continueDisabled
  })), isLimitExceeded && /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: isLimitExceeded,
    modalHeaderText: limitExceededText,
    modalDetailText: limitDetailText,
    modalHeaderIcon: deleteIcon,
    positiveActionButtonTitle: okText,
    positiveAction: limitOkPress
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "speedSetting-body-wrapper"
  }, deleteModal && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: deleteModal,
    modalHeaderText: 'Warning',
    modalHeaderTextStyle: {
      color: '#E00932'
    },
    modalDetailText: 'Are you sure you want to remove this photo?',
    modalHeaderIcon: deleteIcon,
    customIcon: /*#__PURE__*/_react.default.createElement("img", {
      src: trash,
      alt: ""
    }),
    positiveActionButtonTitle: deleteText,
    positiveAction: deleteHandler,
    negativeButtonActionTitle: cancelText,
    negativeAvtion: onCancelDelete
  })), notUploaded && /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: notUploaded,
    modalHeaderText: 'Upload Failed',
    modalHeaderTextStyle: {
      color: '#E00932',
      margin: '20px'
    },
    modalDetailText: "Upload failed for ".concat(totalImagesSelected - totalImagesUploaded, " image(s)"),
    customIcon: /*#__PURE__*/_react.default.createElement("img", {
      src: _images.default.errorIcon.default,
      alt: "",
      style: {
        height: '50px'
      }
    }),
    positiveActionButtonTitle: 'Ok',
    positiveAction: imageNotUploadedClick
  })));
};
var _default = exports.default = ImageUpload;